import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  createRouteRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { productPortfolioApiRef, ProductPortfolioClient } from './api';
import DashboardIcon from '@material-ui/icons/Dashboard';

const rootRouteRef = createRouteRef({ id: 'product-portfolio' });

const productPortfolioPage = PageBlueprint.make({
  params: {
    path: 'product-portfolio',
    title: 'Product Portfolio',
    icon: <DashboardIcon fontSize="inherit" />,
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/PortfolioLayout').then(m => <m.PortfolioLayout />),
  },
});

const productPortfolioApi = ApiBlueprint.make({
  params: define =>
    define(
      createApiFactory({
        api: productPortfolioApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new ProductPortfolioClient({ discoveryApi, fetchApi }),
      }),
    ),
});

export const productPortfolioPlugin = createFrontendPlugin({
  pluginId: 'product-portfolio',
  routes: {
    root: rootRouteRef,
  },
  extensions: [productPortfolioPage, productPortfolioApi],
});

export default productPortfolioPlugin;
